<section class="planet-grid-panel">
  <h3>{{ labels().title }}</h3>
  <div class="planet-rows">
    @for (row of rows(); track row.displayConfig.key) {
      <div class="planet-row" [attr.data-planet-key]="row.displayConfig.key">
        <span class="planet-glyph">{{ row.displayConfig.astronomiconChar }}</span>
        <div class="transit-cell">
          <hd-just-now-planet-activation-cell
            [activation]="row.activation"
            kind="transit"
            fixing="none"
            [transitFixing]="row.fixing"
            [contextMenuEnabled]="contextMenuEnabled()"
            (activationClicked)="planetActivationClicked.emit($event)"
            (contextMenuRequested)="planetBlockContextMenuRequested.emit($event)"
          />
        </div>
      </div>
    }
    @if (chiron(); as chironVm) {
      <div class="planet-row planet-row--chiron" data-planet-key="chiron" [title]="chironVm.tooltip">
        <span class="planet-glyph">{{ chironVm.glyph }}</span>
        <span class="chiron-value">{{ chironVm.gate }}.{{ chironVm.line }}</span>
      </div>
    }
  </div>
</section>
